/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-24T09:31:31.171
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseTag,
	listRentHouseTagInit,
	listRentHouseTagByAuthorizations,
	deleteRentHouseTag
	
} from '@api/rentmanage/RentHouseTag';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseTag({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTag(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTagByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTagByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTagInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTagInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseTag({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseTag({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
